
















import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component({
  name: 'bpc-header-search-box',
  components: {},
})
export default class HeaderSearchBox extends Vue {
  searchOpen: boolean = false;
}
